









































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";

import AppVue from "@/apps/AppVue.vue";
import CourseAttendeeExamDetailsDialog from "@/components/course-session/CourseAttendeeExamDetailsDialog.vue";
import {
  CourseSessionModel,
  CourseSessionAttendeesPrerequisiteCollectionModel,
  CourseSessionPrerequisiteCollectionModel,
} from "@/core/models";
import { CourseSessionService } from "@/core/services";
import { CourseExamSubmissionType } from "@/core/constants";

@Component({
  components: {
    CourseAttendeeExamDetailsDialog,
  },
})
export default class CourseSessionAttendeesPrerequisites extends AppVue {
  @Prop() courseSession: CourseSessionModel;
  attendees: CourseSessionAttendeesPrerequisiteCollectionModel[] = [];
  courseSessionId: number;
  isExamDetailsDialogOpen = false;
  selectedCourseAttendeeId: number | null = null;

  async created() {
    await this.bindData();
  }

  @Watch("$route", { deep: true })
  async bindData() {
    this.courseSessionId = Number(this.$route.params.id);
    const loading = this.$loading({
      lock: true,
      text: this.localiseString("common.gettingData"),
    });

    try {
      await this.initializeModel();
    } catch (err) {
      this.handleApiGetError(err);
    } finally {
      loading.close();
    }
  }

  private async initializeModel() {
    if (!!this.courseSessionId) {
      this.attendees = await CourseSessionService.getAttendeesPrerequisites(
        this.courseSessionId,
      );

      this.$forceUpdate();
    }
  }

  getPrerequisiteGroups(attendee: CourseSessionAttendeesPrerequisiteCollectionModel) {
    const prerequisites = attendee.prerequisites || [];
    const preTraining = prerequisites.filter(
      (p) => p.submissionTypeId === CourseExamSubmissionType.PreTrainingAssessment,
    );
    const other = prerequisites.filter(
      (p) => p.submissionTypeId !== CourseExamSubmissionType.PreTrainingAssessment,
    );

    return {
      preTraining,
      other,
      showGroupHeaders: preTraining.length > 0 && other.length > 0,
    };
  }

  private handleViewExamDetails(
    prerequisite: CourseSessionPrerequisiteCollectionModel,
  ) {
    if (!prerequisite.courseAttendeeId) {
      return;
    }

    this.selectedCourseAttendeeId = prerequisite.courseAttendeeId;
    this.isExamDetailsDialogOpen = true;
  }

  private onCloseExamDetailsDialog() {
    this.isExamDetailsDialogOpen = false;
    this.selectedCourseAttendeeId = null;
  }
}
